export const nl = {
  "app.title": "survivrr.io",
  "menu.online": "Online",
  "menu.offline": "Offline",
  "menu.play": "Spelen",
  "menu.name": "Naam",
  "menu.ballColor": "Balkleur",
  "menu.nameColor": "Naamkleur",
  "menu.moreInfo": "Meer info",
  "menu.moreInfoTitle": "Meer info",
  "menu.moreInfoSubtitle": "Juridische pagina’s, cookiegegevens en contactinformatie.",
  "menu.back": "Terug",
  "menu.privacySettings": "Privacy-instellingen",
  "menu.cookiePolicy": "Cookiebeleid",
  "menu.privacyPolicy": "Privacybeleid",
  "menu.termsOfService": "Servicevoorwaarden",
  "menu.emailButton": "E-mail mij",
  "menu.websiteButton": "Bekijk mijn website",
  "menu.contactEmailLabel": "Contact-e-mail:",
  "menu.emailLabel": "E-mail:",
  "menu.websiteLabel": "Bekijk mijn website:",
  "menu.nameRequired": "Voer eerst een naam in.",
  "moreInfo.privacySettings.intro1": "Je kunt je privacykeuzes op deze site beheren via het toestemmingsbericht van onze advertentieprovider wanneer dit beschikbaar is.",
  "moreInfo.privacySettings.intro2": "Je kunt cookies en lokale opslag ook op elk moment beheren via de instellingen van je browser.",
  "moreInfo.privacySettings.adsHeading": "Advertentie-instellingen",
  "moreInfo.privacySettings.adsParagraph": "Sommige advertenties kunnen worden geleverd door Google of andere partners. Keuzes voor gepersonaliseerde advertenties kunnen ook rechtstreeks worden beheerd in de advertentie-instellingen van Google.",
  "moreInfo.privacySettings.adsBullet1": "Open de advertentie-instellingen van Google op myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Wis cookies of sitegegevens als je je toestemmingskeuzes wilt resetten.",
  "moreInfo.privacySettings.adsBullet3": "Gebruik de privacy-instellingen van je browser om cookies te blokkeren of te beperken.",
  "moreInfo.privacySettings.localHeading": "Lokale instellingen",
  "moreInfo.privacySettings.localParagraph": "Deze game slaat eenvoudige lokale voorkeuren op, zoals je spelersnaam, kleuren, geluidsvoorkeur en taal, zodat de site ze op je apparaat kan onthouden.",
  "moreInfo.cookiePolicy.intro1": "Deze site gebruikt cookies en vergelijkbare opslagtechnologieën om de game te laten werken, je instellingen te onthouden en advertenties te ondersteunen.",
  "moreInfo.cookiePolicy.intro2": "Cookies kunnen ook worden gebruikt voor metingen, fraudepreventie en advertentiepersonalisatie, afhankelijk van je toestemmingskeuzes en de diensten die op de site zijn ingeschakeld.",
  "moreInfo.cookiePolicy.typesHeading": "Soorten cookies en opslag die we kunnen gebruiken",
  "moreInfo.cookiePolicy.typeBullet1": "Essentiële opslag die nodig is om de site te laten werken.",
  "moreInfo.cookiePolicy.typeBullet2": "Voorkeursopslag om je naam, kleuren, taal en geluidsinstelling te onthouden.",
  "moreInfo.cookiePolicy.typeBullet3": "Advertentie- of meetcookies die worden gebruikt door advertentiepartners zoals Google wanneer advertenties zijn ingeschakeld.",
  "moreInfo.cookiePolicy.manageHeading": "Cookies beheren",
  "moreInfo.cookiePolicy.manageParagraph": "Je kunt cookies beheren via het toestemmingsbericht op de site wanneer dit beschikbaar is, of via je browserinstellingen. Het uitschakelen van sommige cookies kan functies of advertentieweergave beïnvloeden.",
  "moreInfo.privacyPolicy.intro1": "Deze site is een browsergame beheerd door Michał Kierzkowski. We proberen zo weinig mogelijk persoonlijke informatie te verzamelen.",
  "moreInfo.privacyPolicy.intro2": "Er is geen account nodig om te spelen. De game kan eenvoudige lokale voorkeuren op je apparaat opslaan en gameplaygegevens verwerken die nodig zijn voor online wedstrijden.",
  "moreInfo.privacyPolicy.infoHeading": "Informatie die we kunnen verwerken",
  "moreInfo.privacyPolicy.infoBullet1": "Je gekozen spelersnaam en cosmetische instellingen.",
  "moreInfo.privacyPolicy.infoBullet2": "Basisgegevens van sessies die nodig zijn voor multiplayerfuncties.",
  "moreInfo.privacyPolicy.infoBullet3": "Apparaat-, browser- of advertentiegegevens die worden verzameld door analyse- of advertentiepartners als die diensten zijn ingeschakeld.",
  "moreInfo.privacyPolicy.useHeading": "Hoe we informatie gebruiken",
  "moreInfo.privacyPolicy.useBullet1": "Om de game en online kamers te laten werken.",
  "moreInfo.privacyPolicy.useBullet2": "Om je instellingen op je apparaat te onthouden.",
  "moreInfo.privacyPolicy.useBullet3": "Om prestaties, veiligheid en stabiliteit te verbeteren.",
  "moreInfo.privacyPolicy.useBullet4": "Om advertenties weer te geven wanneer advertenties zijn ingeschakeld.",
  "moreInfo.privacyPolicy.contactHeading": "Contact",
  "moreInfo.privacyPolicy.contactParagraph1": "Voor vragen over privacy kun je contact opnemen via: mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Website: michalkierzkowski.com",
  "moreInfo.terms.intro1": "Door deze site te gebruiken, ga je akkoord met eerlijk en rechtmatig gebruik van de game.",
  "moreInfo.terms.intro2": "De game wordt aangeboden zoals deze is en kan op elk moment worden gewijzigd, onderbroken of verwijderd.",
  "moreInfo.terms.rulesHeading": "Regels",
  "moreInfo.terms.ruleBullet1": "Misbruik geen bugs, cheats, automatisering of exploits.",
  "moreInfo.terms.ruleBullet2": "Probeer de dienst of andere spelers niet te schaden.",
  "moreInfo.terms.ruleBullet3": "Gebruik geen beledigende, illegale of misleidende namen of inhoud.",
  "moreInfo.terms.limitationHeading": "Beperking",
  "moreInfo.terms.limitationParagraph": "Wij zijn niet verantwoordelijk voor verliezen, onderbrekingen of schade als gevolg van het gebruik van de site, voor zover wettelijk toegestaan.",
  "moreInfo.terms.changesHeading": "Wijzigingen",
  "moreInfo.terms.changesParagraph": "Deze voorwaarden kunnen in de toekomst worden bijgewerkt. Door de site na updates te blijven gebruiken, accepteer je de bijgewerkte voorwaarden.",
  "status.offline": "Offline wedstrijd starten...",
  "status.connecting": "Verbinden met server...",
  "queue.title": "Wachten op een kamer",
  "queue.menu": "Terug naar hoofdmenu",
  "game.pressToMove": "Druk ergens om te bewegen",
  "game.touchToMove": "Tik ergens om te bewegen",
  "game.leaderboard": "Ranglijst",
  "game.hp": "HP",
  "game.level": "Level",
  "game.xp": "XP",
  "game.respawning": "Opnieuw verschijnen...",
  "gameEnd.title": "Einde spel",
  "gameEnd.winTitle": "Je wint",
  "gameEnd.subtitle": "De wedstrijd is afgelopen. Verschijn opnieuw om de volgende ronde te starten of keer terug naar het menu.",
  "pause.title": "Spelmenu",
  "pause.resume": "Doorgaan",
  "pause.menu": "Terug naar hoofdmenu",
  "upgrade.title": "Kies een upgrade",
  "upgrade.generic.title": "Upgrade",
  "upgrade.generic.description": "Verbeter je build.",
  "upgrade.newWeaponPrefix": "Nieuw wapen:",
  "upgrade.stat.maxHp.title": "Max HP",
  "upgrade.stat.maxHp.description": "Verhoog maximale HP.",
  "upgrade.stat.speed.title": "Bewegingssnelheid",
  "upgrade.stat.speed.description": "Verhoog bewegingssnelheid.",
  "upgrade.stat.generic.title": "Stat-upgrade",
  "upgrade.stat.generic.description": "Verbeter je statistieken.",
  "upgrade.weapon.projectileShot.title": "Projectielschot",
  "upgrade.weapon.projectileShot.description": "Voeg projectielschoten toe aan je build.",
  "upgrade.weapon.orbitingBalls.title": "Orbitale ballen",
  "upgrade.weapon.orbitingBalls.description": "Voeg orbitale ballen toe aan je build.",
  "upgrade.weapon.damageZone.title": "Schadezone",
  "upgrade.weapon.damageZone.description": "Voeg een schadezone rond je personage toe.",
  "upgrade.weapon.generic.title": "Wapen",
  "upgrade.weapon.generic.description": "Voeg dit wapen toe aan je build.",
  "upgrade.weaponUpgrade.frequency.title": "Frequentie",
  "upgrade.weaponUpgrade.frequency.description": "Val vaker aan.",
  "upgrade.weaponUpgrade.range.title": "Bereik",
  "upgrade.weaponUpgrade.range.description": "Vergroot het bereik van het wapen.",
  "upgrade.weaponUpgrade.projectileCount.title": "Aantal projectielen",
  "upgrade.weaponUpgrade.projectileCount.description": "Maak meer projectielen.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Projectielsnelheid",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Maak projectielen sneller.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Orbitale snelheid",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Laat orbitale ballen sneller draaien.",
  "upgrade.weaponUpgrade.damage.title": "Schade",
  "upgrade.weaponUpgrade.damage.description": "Doe meer schade.",
  "upgrade.weaponUpgrade.generic.title": "Wapenupgrade",
  "upgrade.weaponUpgrade.generic.description": "Verbeter dit wapen.",
  "defeat.title": "Verslagen",
  "defeat.subtitle": "Verschijn opnieuw of keer terug naar het menu",
  "defeat.respawn": "Respawn",
  "defeat.menu": "Hoofdmenu",
  "error.generic": "Er is iets misgegaan.",
} as const;
